import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Paper,
  CircularProgress,
  Alert
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import store from '..';

const FileListPopup = ({ open, onClose, empId, appId }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const rowSx = { height: 36, '& td, & th': { py: 0.5 } };

  useEffect(() => {
    if (open) {
      setLoading(true);
      setError('');
    var url = store.getState().globalurl.empGetAttachmentUrl;

      axios
        .get(url, {
          params: {
            empId,
            appId
          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setLoading(false));
    }
  }, [open, empId, appId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Uploaded Files</DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 20 }}>
            <CircularProgress />
          </div>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow sx={rowSx}>
                  <TableCell><strong>SL#</strong></TableCell>
                  <TableCell><strong>Filename</strong></TableCell>
                  <TableCell><strong>Uploaded Date</strong></TableCell>
                  <TableCell><strong>View</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {files.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No files uploaded yet.
                    </TableCell>
                  </TableRow>
                ) : (
                  files.map((file, index) => (
                    <TableRow key={file.id || index} sx={rowSx}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{file.filename}</TableCell>
                      <TableCell>{file.uploadedDate}</TableCell>
                      <TableCell>
                        <Tooltip title="Open File">
                          <IconButton
                            color="primary"
                            component="a"
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                          >
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FileListPopup;
